import { post } from '@/lib/request/index';
import { bill } from '../apiConstants';

// 发单页初始化信息
export function getBillIndex(param) {
  return post(bill.BILL_INDEX, { param })
    .then((res) => res)
    .catch(() => false);
}

// 发单页计价
export function getBillPrice(param) {
  return post(bill.COMPUTED_PRICE, { param })
    .then((res) => [null, res])
    .catch((err) => [err, null]);
}

// 检查营业时间
export function checkOpenTime(param) {
  return post(bill.CHECK_OPEN_TIME, { param })
    .then((res) => res)
    .catch(() => false);
}
